import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoadingController, NavController, ToastController } from '@ionic/angular';
import { CommandResult } from 'src/app/models/commandResult';
import { LoginViewModel } from 'src/app/models/loginViewModel';
import { Pais } from 'src/app/models/pais';
import { AccountService } from 'src/app/services/account.service';
import { AuthService } from 'src/app/services/auth.service';
import { Security } from 'src/app/utils/security.util';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.page.html',
  styleUrls: ['./sign-up.page.scss'],
})
export class SignUpPage implements OnInit {

  public form: FormGroup;
  public hide = true;
  paisSelected = '+55';
  // imgPais = '../../assets/icon/brasil.png';
  pais: Pais[] = [
    {
      name: 'Brasil',
      initials: 'BR',
      value: '+55',
      ico: '../../assets/icon/brasil.png'
    },
    {
      name: 'Bolivia',
      initials: 'BO',
      value: '+591',
      ico: '../../assets/icon/bolivia.png'
    }
  ];

  constructor(private fb: FormBuilder, private us: AccountService, private authService: AuthService, private toastCtrl: ToastController,
    private navCtrl: NavController, private loadingCtrl: LoadingController) {
    this.form = this.fb.group({
      name: ['', Validators.compose([
        Validators.minLength(10),
        Validators.maxLength(80),
        Validators.required
      ])],
      nick: ['', Validators.compose([
        Validators.minLength(5),
        Validators.maxLength(30),
        Validators.required
      ])],
      email: ['', Validators.compose([
        Validators.required,
        Validators.email
      ])],
      ddi: ['', Validators.compose([
        Validators.required
      ])],
      phone: ['', Validators.compose([
        Validators.required
      ])],
      document: ['', Validators.compose([
        Validators.required
      ])],
      password: ['', Validators.compose([
        Validators.minLength(8),
        Validators.maxLength(20),
        Validators.required
      ])],
      father: ['', Validators.compose([
        Validators.minLength(7),
        Validators.maxLength(7),
        Validators.required
      ])]
    });
  }

  ngOnInit() { }

  async showMessage(messagen) {
    const error = await this.toastCtrl.create({ message: messagen, duration: 3000 });
    error.present();
  }

  async setToken(data) {
    Security.set(data);
  }

  async submit() {
    const loading = await this.loadingCtrl.create({ message: 'Realizando Cadastro...' });
    loading.present();

    this.us.createUser(this.form.value).subscribe(result => {
      if (result.cod === 200) {
        const user = new LoginViewModel();
        user.document = this.form.get('document').value;
        user.password = this.form.get('password').value;

        this.authService.authenticate(user).subscribe((auth: CommandResult) => {
          if (auth.cod === 200) {
            this.setToken(auth.data);
            loading.dismiss();
            this.navCtrl.navigateRoot('/master');
            this.showMessage('Bem vindo ao $M  Digital Wallet');
          }
        });
      } else {
        loading.dismiss();
        console.log(result.data);
        this.showMessage(result.cod + ' ' + result.message);
      }
    }, error => {
      loading.dismiss();
      this.showMessage(error.message);
    });
  }

  toggleHide() {
    this.hide = !this.hide;
  }

  gotToPage(page: string) {
    this.navCtrl.navigateRoot(page);
  }

  // changePais(event){
  //   this.paisSelected = event;

  //   this.form.patchValue({
  //   //   ddi: event,
  //   // });
  // }
}
